import type { StringTable } from '../types'

export const zh: StringTable = {
  'common.playbackSpeed': '播放速度',
  // Navigation
  'nav.review': '复习',
  'nav.library': '词库',
  'nav.stats': '统计',
  'nav.settings': '设置',
  'nav.appTitleSuffix': '词汇闪卡',
  'nav.openMenu': '打开菜单',
  'nav.closeMenu': '关闭菜单',
  'nav.mainNav': '主导航',
  'nav.reviewSession': '复习会话',
  'nav.cardLibrary': '卡片词库',
  'nav.media': '视频',
  'nav.statistics': '统计数据',
  'nav.create.label': '创建',
  'nav.create.text': '文字',
  'nav.create.doc': '文档',
  'nav.create.media': '视频 / 音频',

  // Generate view
  'generate.takePhoto': '拍照',
  'generate.changePhoto': '更换照片',
  'generate.chooseGallery': '相册',
  'generate.clearText': '清除文字',
  'generate.button': '生成卡片',
  'generate.buttonPhoto': '从照片生成',
  'generate.buttonText': '从文字生成',
  'generate.buttonBoth': '从照片+文字生成',
  'generate.buttonLoading': '生成中...',
  'generate.minInput': '添加照片或文字以开始',
  'generate.convertingHeic': '转换 HEIC...',
  'generate.compressing': '压缩中...',
  'generate.retry': '重试',
  'generate.removeImage': '移除图片',
  'generate.cardTextInput': '卡片文字输入',
  'generate.preview': '预览',

  // Generate errors
  'generate.error.invalidImage': '请上传图片（JPEG、PNG、GIF、WebP 或 HEIC）',
  'generate.error.imageTooLarge': '图片不能超过 {{maxSize}}',
  'generate.error.compressionFailed': '压缩后图片仍然过大，请尝试更小的照片',
  'generate.error.heicFailed': '图片处理失败',
  'generate.error.generateFailed': '生成卡片失败',

  // Generate — daily cap / upgrade
  'generate.cap.body': '余额不足（{{balance}} 能量）。充值后继续生成。',
  'generate.cap.upgrade': '充值',

  // Generate — energy badge + first-session banner (balance visibility)
  'generate.energyBadge.label': '能量余额：{{balance}}',
  'generate.energyBadge.zero': '能量已用完',
  'generate.firstCard.body': '你有 {{balance}} 点能量 — 足够生成第一批卡片。在下方输入一个单词试试 →',
  'generate.firstCard.dismiss': '关闭',
  'generate.sampleWords.label': '试试这些词：',
  'generate.aiImageToggle': 'AI 配图',
  'generate.aiImageHint': '给保留的卡片添加 AI 配图(每张 {{cost}} 能量)',
  'generate.aiImageAutoSkip': '部分 AI 配图未能生成 — 点击每张卡片上的图片按钮重试。',

  // Library view
  'library.loading': '加载词库...',
  'library.retry': '重试',
  'library.noCards': '还没有卡片！',
  'library.noCardsHint': '生成一些闪卡来建立你的词库',
  'library.emptyExtensionHint': '小提示:在 YouTube 看视频时划选任意单词,用 Piccard 扩展一键保存。', 'library.emptyCta': '创建第一张卡',
  'library.dismiss': '关闭',
  'library.deleteTitle': '删除卡片？',
  'library.deleteConfirm': '此操作无法撤销，确定要删除吗？',
  'library.cancel': '取消',
  'library.deleting': '删除中...',
  'library.delete': '删除',
  'library.filterAll': '全部',
  'library.filterLearning': '学习中',
  'library.filterMastered': '已掌握',
  'library.card_one': '{{count}} 张卡片',
  'library.card_other': '{{count}} 张卡片',
  'library.match_one': '{{count}} 个匹配',
  'library.match_other': '{{count}} 个匹配',
  'library.noCardsMatch': '没有卡片匹配"{{query}}"',
  'library.prevPage': '上一页',
  'library.nextPage': '下一页',
  'library.searchImagesFor': '搜索 {{word}} 的图片',
  'library.unmaster': '取消掌握 {{word}}',
  'library.markMastered': '标记 {{word}} 为已掌握',
  'library.searchPlaceholder': '搜索{{filter}}卡片...',
  'library.drag': '拖动',
  'library.swipeHint': '← 删除 · 查看 →',
  'library.back': '背面',
  'library.images': '图片',
  'library.master': '掌握',
  'library.mastered': '已掌握',
  'library.view': '查看',
  'library.fromMedia': '来自媒体',
  'library.fromDoc': '来自文档',

  // Review view
  'review.ready': '准备复习？',
  'review.readyHint': '选择一个主题或开始复习所有到期卡片',
  'review.recognition': '识别',
  'review.production': '产出',
  'review.topics': '主题',
  'review.domains': '领域',
  'review.startReview': '开始复习',
  'review.loading': '加载卡片...',
  'review.retry': '重试',
  'review.tapFlip': '点击翻转',
  'review.answer': '答案',
  'review.newWord': '新单词',
  'review.cardProgress': '第 {{current}} 张，共 {{total}} 张',
  'review.searchImagesFor': '搜索 {{word}} 的图片',
  'review.allCaughtUp': '全部复习完了！',
  'review.nothingToReview': '暂时没有需要复习的内容',
  'review.makeSomeCards': '创建一些卡片',
  'review.makeMoreCards': '创建更多"{{topic}}"卡片',
  'review.backToReview': '返回复习',
  'review.noMatchTitle': '没有卡片匹配"{{topic}}"',
  'review.noMatchHint': '包含部分匹配你主题的卡片',
  'review.fallbackTitle': '没有卡片匹配"{{topic}}"——以下是所有到期卡片',
  'review.sessionComplete': '复习完成！',
  'review.cardsReviewed': '已复习卡片',
  'review.again': '再来',
  'review.hard': '困难',
  'review.good': '良好',
  'review.easy': '简单',
  'review.timeSpent': '用时',
  'review.cardReviewed_one': '今天复习了 {{count}} 张卡片',
  'review.cardReviewed_other': '今天复习了 {{count}} 张卡片',
  'review.startNewSession': '开始新会话',

  // Share check-in card (issue #1 — /s/:slug poster pages)
  'share.cta': '分享今日打卡卡片',
  'share.title': '分享学习成果',
  'share.name': '显示名称',
  'share.create': '生成分享链接',
  'share.copied': '链接已复制！',
  'share.open': '打开分享页',
  'share.saveImage': '儲存打卡圖片',
  'share.myLinks': '我的分享链接',
  'share.revoke': '撤销',
  'share.empty': '还没有分享链接——完成一次复习就能分享你的连续打卡。',
  'review.tapOrSpace': '点击卡片或按空格键翻转',
  'review.images': '图片',
  'review.prefillMore': '更多关于{{topic}}的词汇和表达',
  'review.endSession': '结束练习',
  'review.error.loadFailed': '加载卡片失败',
  'review.error.submitFailed': '提交复习结果失败',

  // Stats view
  'stats.today': '今天',
  'stats.reviewedToday': '今日已复习',
  'stats.review_one': '次复习',
  'stats.review_other': '次复习',
  'stats.mastered': '已掌握',
  'stats.learned': '已学会',
  'stats.word_one': '个单词',
  'stats.word_other': '个单词',
  'stats.error': '统计加载失败',
  'stats.dailyGoal': '每日目标',
  'stats.goalFresh': '新的开始。',
  'stats.goalGoing': '继续加油。',
  'stats.goalMet': '达成目标,干得漂亮。',
  'stats.goalHint': '轻点设置节奏',

  // Settings view
  'settings.title': '设置',
  'settings.languagePair': '语言对',
  'settings.learn': '学习',
  'settings.pairOption': '{{native}} → 学习 {{target}}',
  'settings.pairGroup': '{{langA}} ↔ {{langB}}',
  'settings.cardsPerSession': '每轮卡片数',
  'settings.cardLabel': '{{count}} 张卡片',
  'settings.changeWarning': '更改语言将重新加载应用',
  'settings.apply': '应用',
  'settings.cancelChange': '取消',

  // Settings — learning context (free-text goal that tunes AI generation)
  'settings.learningContext.label': '学习目标',
  'settings.learningContext.optional': '可选',
  'settings.learningContext.placeholder': '例如：GRE 词汇、HSK 备考、商务英语…',
  'settings.learningContext.hint': '影响 AI 选词方向，留空则使用默认。',
  'settings.learningContext.try': '试试：',
  'settings.learningContext.example1': 'HSK 备考',
  'settings.learningContext.example2': '商务英语',
  'settings.learningContext.example3': '日常对话',
  'settings.learningContext.example4': '澳洲口语',

  // Settings — subscription
  'settings.plan.balanceTitle': '能量余额',
  'settings.plan.balanceDesc': '可用 {{balance}} 能量',
  'settings.plan.topup': '充值 ${{amount}}',
  'settings.plan.energyUnit': '{{energy}} 能量',
  'settings.plan.bonusPct': '+{{percent}}% 奖励',
  'settings.plan.bestValue': '最超值',
  'settings.support.title': '需要帮助？',
  'settings.support.desc': '问题、账单或反馈 — 随时邮件联系。',
  'settings.referral.title': '邀请好友，双方各得 150 能量',
  'settings.referral.desc': '分享你的链接。好友充值后，你和朋友各得 150 能量免费。',
  'settings.referral.yourCode': '你的邀请码',
  'settings.referral.copyCode': '复制邀请码',
  'settings.referral.tapToCopy': '点按复制',
  'settings.referral.codeCopied': '已复制',
  'settings.referral.shareLink': '分享链接',
  'settings.referral.invited_one': '邀请了 {{count}} 位好友',
  'settings.referral.invited_other': '邀请了 {{count}} 位好友',
  'settings.referral.toppedUp_one': '{{count}} 位已充值',
  'settings.referral.toppedUp_other': '{{count}} 位已充值',
  'settings.referral.pendingHint': '等待对方首次充值 — 提醒一下！',
  'settings.referral.shareText': '用生活照片记单词。你充值后我们各得 150 能量 — 一起来试 Piccard：',
  'settings.referral.rewardBanner': '你的好友已充值 — 账户已加 150 能量。',
  'settings.referral.rewardDismiss': '知道了',
  'settings.referral.haveCode': '有邀请码？',
  'settings.referral.codePlaceholder': '输入邀请码',
  'settings.referral.codeApply': '应用',
  'settings.referral.codeApplying': '应用中…',
  'settings.referral.codeApplied': '邀请码已应用 — 你充值后，你和邀请者各得 150 能量。',
  'settings.referral.codeAlready': '你的账号已绑定邀请关系。',
  'settings.referral.codeInvalid': '邀请码无效。',
  'settings.referral.codeSelf': '这是你自己的邀请码。',

  // Payment (shared)
  'payment.checkoutFailed': '无法开始结账。请重试。',
  'payment.checkoutLoading': '正在跳转到结账…',
  'payment.checkoutSuccess': '充值成功 — 感谢！',
  'payment.checkoutCancelled': '已取消支付。',

  // Hamburger menu
  'menu.notSignedIn': '未登录',
  'menu.signOut': '退出登录',
  'menu.languageLearner': '语言学习者',

  // Onboarding
  'onboarding.iSpeak': '我说…',
  'onboarding.imLearning': '我想学…',
  'onboarding.startLearning': '开始学习',
  'onboarding.changeAnytime': '随时可以更改',
  'onboarding.back': '← 返回',
  'onboarding.learningContext.label': '有特定的学习目标吗？',
  'onboarding.learningContext.placeholder': '例如：GRE、HSK、商务英语…（可选）',

  // Auth
  'auth.signInPrompt': '登录以将词汇保存到云端',
  'auth.continueWithGoogle': '使用 Google 登录',
  'auth.continueWithKakao': '通过 Kakao 继续',
  'auth.signingIn': '登录中...',
  'auth.signingYouIn': '正在为你登录...',
  'auth.signInFailed': '登录失败',
  'auth.signInError': '登录过程中出现了问题',
  'auth.tryAgain': '重试',
  'auth.loading': '加载中...',

  // Error boundary
  'error.title': '出了点问题',
  'error.description': '发生了一个意外错误',
  'error.tryAgain': '重试',
  'error.report': '报告',

  // Offline
  'offline.title': '你已离线',
  'offline.description': '部分功能可能受限，请检查网络连接',
  'offline.notification': '离线通知',
  'offline.retryConnection': '重新连接',

  // PWA install
  'pwa.installPrompt': '安装 Piccard 以离线使用',
  'pwa.install': '安装',
  'pwa.dismiss': '关闭',
  'pwa.installAppPrompt': '安装应用提示',
  'pwa.installApp': '安装应用',

  // Card stack
  'cardStack.cardGenerated': '生成了 1 张卡片',
  'cardStack.cardGenerated_other': '生成了 {{count}} 张卡片',
  'cardStack.counter': '{{current}} / {{total}} 张卡片',
  'cardStack.done': '完成',
  'cardStack.reviewNow': '立即复习',
  'cardStack.generateMore': '继续生成',
  'cardStack.allReviewed': '所有卡片已查看',
  'cardStack.cardsSaved': '{{count}} 张卡片已保存',
  'cardStack.previousCard': '上一张卡片',
  'cardStack.nextCard': '下一张卡片',
  'cardStack.goToCard': '跳转到第 {{n}} 张',

  // Preview card
  'previewCard.generatedCard': '生成的卡片',
  'previewCard.translation': '翻译',
  'previewCard.definition': '释义',
  'previewCard.example': '例句',
  'previewCard.searchImagesFor': '搜索 {{word}} 的图片',

  // Rating buttons
  'rating.again': '再来',
  'rating.hard': '困难',
  'rating.good': '良好',
  'rating.easy': '简单',
  'rating.master': '掌握',
  'rating.rateAs': '评为 {{label}}',
  'rating.markMastered': '标记为已掌握',
  'review.stuckHint': "这张卡滑走了 {{count}} 次 — 不是你的问题,有些卡就是记不住。在下面退休它,或继续刷。",

  // Study card
  'studyCard.studyCardFor': '{{word}} 的学习卡片',
  'studyCard.playUsPronunciation': '播放美式发音',
  'studyCard.playUkPronunciation': '播放英式发音',
  'studyCard.searchImagesFor': '搜索 {{word}} 的图片',

  // Pronunciation button + badge
  'pronunciation.play': '播放 {{accent}} 发音',

  // Search bar
  'search.clearSearch': '清除搜索',

  // Tag cloud
  'tagCloud.yourTopics': '你的主题',
  'tagCloud.showMore': '显示更多 {{count}} 个{{label}}',

  // Queue item
  'queueItem.remove': '移除 {{word}}',

  // Error card
  'errorCard.defaultRetry': '重试',

  // Empty state
  'emptyState.noCards': '还没有卡片',
  'emptyState.noCardsHint': '创建你的第一张闪卡开始学习',
  'emptyState.createCard': '创建卡片',
  'emptyState.noMastered': '还没有已掌握的单词',
  'emptyState.noMasteredHint': '将卡片标记为已掌握即可在这里查看',
  'emptyState.allMastered': '所有卡片都已掌握！',
  'emptyState.greatJob': '做得好！',

  // Progress bar
  'progressBar.cardsLearned': '已学卡片',

  // AI image regeneration (shared RegenerateImageButton)
  'common.aiImage': 'AI 图片',
  'common.aiImagePremium': 'Premium',
  'common.aiImageAria': '为「{{word}}」生成 AI 图片',
  'common.generating': '生成中…',
  'common.imageFailed': '失败 · 未消耗能量',
  'common.lowEnergy': '能量不足',
  'common.regenerateCard': '重新生成',
  'common.regenerateCardAria': '完全重新生成 {{word}}',

  // Image preview / lightbox
  'imagePreview.enlarge': '放大图片',
  'imagePreview.close': '关闭',

  // Document import view (PDF/TXT → candidate vocab)
  'importView.title': '导入文档',
  'importView.subtitle': '把 PDF 或文本变成单词卡。',
  'importView.chooseFile': '选择 PDF 或文本文件',
  'importView.pasteLabel': '或粘贴文本',
  'importView.pastePlaceholder': '粘贴文章、笔记或任意文本…',
  'importView.findVocab': '查找词汇',
  'importView.proposing': '正在查找词汇…',
  'importView.proposingWait': '正在挑词并撰写释义——长文本通常需要 10–20 秒。',
  'importView.phaseReading': '正在通读文本…',
  'importView.foundSoFar': '已找到 {{n}} 个 · 还在找…',
  'importView.cancel': '取消',
  'importView.partialBanner': '已找到 {{n}} 个词,但分析中途中断了。',
  'importView.retryRest': '补齐剩余',
  'importView.parsing': '正在读取文档…',
  'importView.candidates': '{{count}} 个候选词',
  'importView.keepN': '保留 {{count}} · {{energy}} 能量',
  'importView.generate': '生成 {{count}} 张卡片',
  'importView.selectAll': '全选',
  'importView.clearAll': '清空',
  'importView.priorityHigh': '高价值',
  'importView.highCount': '高价值 {{high}} / 共 {{total}}',
  'mediaView.selectRecommended': '选择推荐',
  'importView.success': '已添加 {{count}} 张卡片到词库',
  'importView.pairMismatch': '卡片将存为 {{pair}} — 当前应用设置为 {{current}}。复习前需在设置中切换。',
  'importView.savedAs': '已按 {{pair}} 保存',
  'importView.reviewInPair': '切换到 {{pair}} 并复习',
  'importView.reviewNow': '立即复习',
  'importView.errorTooLarge': '文档太大(最多约 80 万字符)。',
  'importView.errorScanned': '没有可选文本——这看起来是扫描版 PDF。',
  'importView.errorRead': '无法读取该文件。',
  'importView.errorPropose': '无法提取词汇,请重试。',
  'importView.errorRateLimited': '操作太频繁了,等一分钟再试。',
  'importView.errorLowEnergy': '能量不足,无法保存这些卡片。',
  'importView.empty': '未找到词汇,试试其他文档。',

  // Quick save view (extension lookup → one-step card)
  'quickSave.title': '保存到 Piccard',
  'quickSave.subtitle': '一键生成,马上就能复习。',
  'quickSave.generate': '生成卡片',
  'quickSave.generateCost': '生成卡片 · {{energy}} 能量',
  'quickSave.generating': '正在制作卡片…',
  'quickSave.slowWait': '制作卡片通常需要几秒钟——稍等片刻。',
  'quickSave.pairSourceExtension': '来自这个视频',
  'quickSave.pairSourceSettings': '你的应用设置',
  'quickSave.pairSourceBrowser': '你的浏览器语言',
  'quickSave.fromYoutube': '来自这个视频',
  'quickSave.fromNetflix': '来自本剧集',
  'quickSave.pairLabel': '卡片语言',
  'quickSave.energyHint': '生成消耗 {{energy}} 能量 · 余额 {{balance}}',
  'quickSave.errorBalance': '能量不足,无法生成这张卡。',
  'quickSave.errorNetwork': '生成失败,请重试。',
  'quickSave.topUp': '充值',
  'card.fromSource': '来自你的文档',
  'card.grammar': '语法',
  'card.prosody': '重音与节奏',
  'card.fromClip': '片段',
  'card.fromYoutube': 'YouTube',
  'card.openInNetflix': '在 Netflix 中打开',
  'card.fromNetflix': 'Netflix',
  'card.fromPdf': 'PDF',
  'card.fromPhoto': '你的照片',
  'card.lookedUp': '查词',
  'card.expand': '展开',
  'card.collapse': '收起',

  // 音视频 → 卡片
  'mediaView.title': '把片段变成卡片',
  'mediaView.subtitle': '上传英文音频或视频,我们转写,你来挑。',
  'mediaView.chooseFile': '拖入文件或点此选择',
  'mediaView.formats': 'mp4 · mov · webm · mp3…',
  'mediaView.cap': '最长 90 分钟 · 最大 100MB',
  'mediaView.guideExtension.body': '已装扩展?在 YouTube/Netflix 视频页上选中字幕里的词,点 Piccard 按钮即可存卡;也可以在下方导入你自己的视频/音频文件 →',
  'mediaView.guideExtension.dismiss': '关闭',
  'mediaView.uploading': '上传中…',
  'mediaView.transcribe': '转写',
  'mediaView.transcribing': '转写中…',
  'mediaView.transcribeHint': '短视频几秒就好。',
  'mediaView.changeFile': '换一个文件',
  'mediaView.costN': '{{energy}} 能量',
  'mediaView.phrases': '{{count}} 个短语',
  'mediaView.make': '生成 {{count}} 张卡片',
  'mediaView.uncertain': '这句建议核对',
  'mediaView.preview': '播放这句',
  'mediaView.success': '{{count}} 张卡片已进入复习',
  'mediaView.errorUpload': '上传失败,请重试。',
  'mediaView.errorTooLarge': '超过 100MB——先剪短一些。',
  'mediaView.errorSilent': '未检测到人声。可能是静音视频——请选择有对白的片段。',
  'mediaView.errorFormat': '格式不支持,请用 mp4、mov、webm 或音频文件。',
  'mediaView.errorTranscribe': '转写服务繁忙,请重试——本次未扣费。',
  'mediaView.tooLongDuration': '超过 {{n}} 分钟——请把片段剪短后再添加。',
  'mediaView.errorContent': '未在此文件中检测到英文语音。',
  'mediaView.errLanguageMismatch': '这段音视频听起来不是{{lang}}。请选择{{lang}}素材，或先切换学习语言。',
  'mediaView.errBadFormat': '这个文件的真实格式无法转写（比如 .avi/.mkv 改名成 .mp4）。请转成 mp4、mov、webm 或常见音频格式。',
  'mediaView.errNoSpeech': '未在此文件中检测到语音。请选择有清晰对话的片段。',
  'mediaView.errDecode': '无法处理该文件的音频。请换用标准的 mp4、mov、webm 或音频文件。',
  'mediaView.fromFile': '来自 {{name}}',
  'mediaView.errorLowEnergy': '能量不足。',
  'mediaView.errorConfirm': '无法根据这些短语生成卡片,请重试。',
  'mediaView.empty': '此片段未找到短语。',
  'mediaView.costEstimate': '约 {{cost}} 能量 · 约 {{min}} 分钟',
  'mediaView.feeApplied': '（已扣除 {{n}} 能量检测费）',
  'settings.section.energy': '能量',
  'settings.section.learning': '学习',
  'redeem.title': '兑换码',
  'redeem.desc': '输入兑换码以获取能量。',
  'redeem.placeholder': '输入兑换码',
  'redeem.apply': '兑换',
  'redeem.applying': '…',
  'redeem.success': '兑换成功！+{{cents}} 能量',
  'redeem.already': '你已经兑换过此码。',
  'redeem.invalid': '无效或过期的兑换码',
  'redeem.error': '出错了，请重试。',
  'redeem.balance': '{{balance}} 能量可用',

  // Landing (v11 — extension-first entry, closed loop) — zh-Hans, mainland terminology.
  // Copy frozen in docs/plans/landing-v11.md; keywords per docs/plans/seo-research/zh-keywords.md.
  'landing.hero.title': '看 YouTube\n记英语单词',
  'landing.hero.subtitle': '在你看的英语视频上开启中英对照字幕。点一下字幕行,再点一次生成单词卡 — 释义、例句、发音都在卡上,每张都会在快忘掉时再次出现。',
  'landing.hero.cta': '免费开始',
  'landing.hero.ctaNote': '免费,不用绑卡。',
  'landing.hero.ctaExtension': '添加到 Chrome',
  'landing.hero.videoCaption': '从中英对照面板进入 Piccard — 一行字幕变成几张候选单词卡。',
  'landing.how.title': '点击字幕查单词',
  'landing.how.subtitle': '从 YouTube 到单词卡 — 你看的,就是你复习的。',
  'landing.how.step1Title': '开着双语字幕看视频',
  'landing.how.step1Desc': 'Chrome 扩展在你正在看的视频上叠加母语字幕 — 逐行同步,精确到秒。',
  'landing.how.step2Title': '点一行字幕,留下单词卡',
  'landing.how.step2Desc': '点一下字幕行,把它发到 Piccard,再点一下生成单词卡 — 每张都带释义、例句、发音。值得留的留下,不要的丢掉。',
  'landing.how.step3Title': '复习会自己回来',
  'landing.how.step3Desc': 'FSRS 间隔重复替每张卡安排回来的时间,总在你快忘掉之前 — 而且每张卡都能回放它在 YouTube 上的出处那一刻。',
  'landing.how.otherTitle': '其他入口',
  'landing.how.other3': '在网页上双击一个词 — 离线释义立刻出现,再点一下,Piccard 就把卡片做好。',
  'landing.how.ownLink': '已经有词表了?直接带来 →',

  // landing-v12 P1-2: persona-2 section (OwnMaterial.tsx) — bring your own list
  'landing.bring.title': '已有的词表,直接变卡',
  'landing.bring.subtitle': '视频只是入口之一。你真正需要的词,大多已经躺在某处 — 教材的一章、考纲词表、讲课录音。粘贴或上传,Piccard 提议卡片,你只留下值得学的。',
  'landing.bring.pasteTitle': '粘贴文本',
  'landing.bring.pasteDesc': '教材一页、一篇文章、手里现成的词表。粘贴进来,候选卡片就会回来 — 可以全选,也可以只留值得学的。每次确认最多 20 张。',
  'landing.bring.pdfTitle': '拖入 PDF',
  'landing.bring.pdfDesc': '课程材料、考纲词表、阅读讲义 — PDF 走同一条提议流程。卡片排开,勾选,一次确认。',
  'landing.bring.fileTitle': '上传音频/视频',
  'landing.bring.fileDesc': '英语讲课或播客录音(最长 90 分钟)会被转写,每句附 0–100 的值得学分数(计入你的学习目标),值得留的预先勾好。可上传的是你所学语言的音频(学英语即英语讲课)。',
  'landing.bring.cta': '打开应用',
  'landing.bring.ctaNote': '免费开始,无需信用卡。',
  'landing.pricing.title': '用多少,付多少',
  'landing.pricing.subtitle': '注册送能量,随时充值,永不过期。',
  'landing.pricing.starter': '起步版',
  'landing.pricing.starterPrice': '$0',
  'landing.pricing.starterToBegin': '起',
  'landing.pricing.starterGrant': '注册送 150 能量',
  'landing.pricing.starterSwitch': '语言随时切换',
  'landing.pricing.starterSrs': '完整的间隔重复复习',
  'landing.pricing.starterDevices': '任何设备都能用',
  'landing.pricing.starterSync': '含云端同步',
  'landing.pricing.starterCta': '开始使用',
  'landing.pricing.topup': '充值包',
  'landing.pricing.topupRate': '1 能量 ≈ 1 张文字卡',
  'landing.pricing.starterAiImage': '含文字卡;AI 图片卡是付费功能',
  'landing.pricing.topupCards': '$5 = 500 张卡',
  'landing.blog.backHome': '← 返回首页',
  'landing.welcome.openApp': '打开 Piccard',
  'landing.faq.heading': '常见问题',
  'landing.faq.q1': '真的免费吗?',
  'landing.faq.a1': '真的!每个新账号都送 150 免费能量,够做好几段视频、几份 PDF,或大约 150 张卡片。想要更多时再买能量包($5/$10/$20)。能量永不过期。',
  'landing.faq.q2': '和 Language Reactor、Anki 有什么不同?',
  'landing.faq.a2': '两个都是好工具,但中间有个断层:Language Reactor 只管显示字幕,存词得导出再导入 Anki;而 Anki 本身要花功夫配置,每张卡都得自己动手做。Piccard 补上这个断层。点一下字幕行,卡片已经做好 — 释义、例句、发音齐全 — 值得留的留下,不要的丢掉,复习排程交给 Anki 也在用的最新 FSRS-6。导入较长的视频时,每个短语都会得到 0–100 的值得学分数,悬停可看一行理由,学习目标也计入其中——哪个词值得花时间,不用再猜。不用配置,不用导出导入。',
  'landing.faq.q3': '会让 YouTube 变慢或破坏字幕吗?',
  'landing.faq.a3': '不会。扩展很轻量 — 它在视频上方加上自己的字幕面板,不会改动 YouTube 本身。哪天不想要了,一次点击全部移除。不需要账号也能用。',
  'landing.faq.q5': '什么是间隔重复?',
  'landing.faq.a5': '一种排程算法决定每张卡什么时候回来 — 刚学还新鲜时来得勤,沉淀进长期记忆后越来越疏。Piccard 用的是 Anki 也在用的最新一代 FSRS-6,而你的卡片来自你看过的、读过的内容。',
  'landing.faq.q7': '支持哪些语言?',
  'landing.faq.a7': '한국어 · 繁體中文 · 日本語 优先 — Piccard 专为学英语的韩语、繁体中文和日语使用者打造。西班牙语、法语、德语也可使用,随时切换。',

  'landing.faq.q8': '我已经有一份词表,Piccard 能把它变成卡吗?',
  'landing.faq.a8': '能 — 这是最快的入口。粘贴文本或拖入 PDF,Piccard 就会提议卡片(每次最多 20 张):释义、例句、发音俱全。讲课录音也行 — 上传音频会被转写,每句附 0–100 的值得学分数。',
  'landing.faq.q9': 'Netflix 上能用吗？',
  'landing.faq.a9': '可以，有文本字幕的剧集都支持。若片源同时提供两种语言的字幕，视频上还能显示双语字幕（英语＋你的母语）。开着面板观看，点一句台词即生成卡片，卡片能按精确到秒的时间点跳回 Netflix。少数片源是图片字幕、无法读取；受 DRM 限制也不能截屏或保存原声——留下的是单词和那个瞬间。',
  'landing.faq.still': '还有疑问?发邮件到',
  'landing.footer.tagline': '单词卡,来自你看的视频',
  'landing.footer.blog': '博客',
  'landing.footer.privacy': '隐私',
  'landing.footer.terms': '条款',
  'landing.footer.contact': '联系我们',
  'landing.footer.rights': '保留所有权利。',
  'landing.finalCta.title': '你的第一张卡片,只差一个 YouTube 视频',
  'landing.finalCta.subtitle': '看个视频。点一行字幕。做好卡片 — 它会在你忘记之前回来。',
  'landing.finalCta.cta': '免费开始',
  'landing.finalCta.ctaExtension': '添加到 Chrome',
  'landing.finalCta.note': '无需绑卡。含 150 能量。',

  // SEO — prerendered HTML shells (docs/plans/multilingual-seo.md M1)
  'seo.title': 'YouTube 双语字幕 + 点字幕生成单词卡 — Piccard',
  'seo.description': 'YouTube 双语字幕,中英对照显示。点一下字幕行,带释义和出处句的单词卡直接备好,值得学的留下;FSRS 间隔重复会在快忘掉时带它们回来。免费开始。',
}
